import {useAction} from '@github-ui/code-view-shared/contexts/ActionContext'
import {usePath} from '@github-ui/code-view-shared/contexts/PathContext'
import {useRefInfo} from '@github-ui/code-view-shared/contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {Breadcrumb} from '@github-ui/repos-breadcrumb'
import type {TooltipProps} from '@primer/react'

export function ReposHeaderBreadcrumb({
  fileNameId = 'file-name-id',
  id,
  size,
  showCopyPathButton,
  copyButtonTooltipDirection,
}: {
  fileNameId?: string
  id?: string
  size?: 'md' | 'lg'
  showCopyPathButton?: boolean
  copyButtonTooltipDirection?: TooltipProps['direction']
}) {
  const repo = useCurrentRepository()
  const path = usePath()
  const action = useAction()
  const refInfo = useRefInfo()

  return (
    <Breadcrumb
      path={path}
      repo={repo}
      commitish={refInfo.name}
      isFolder={action === 'tree'}
      fileNameId={fileNameId}
      id={id}
      size={size}
      showCopyPathButton={showCopyPathButton && path !== '' && path !== '/'}
      copyButtonTooltipDirection={copyButtonTooltipDirection}
    />
  )
}
